import React from 'react'

import { Form, Input } from 'antd'
import MaskedInput from 'antd-mask-input'

interface InputProps {
  methods: any
  scope: string
  name: string
  label: string
  mask?: string
  type: 'text' | 'password' | 'number' | 'masked'
}

export const InputText = ({
  methods,
  name,
  label,
  scope,
  mask,
  type,
}: InputProps) => {
  const {
    register,
    formState: { errors },
  } = methods

  return (
    <Form.Item
      label={label}
      name={name}
      className={errors[name] && 'has-error'}
    >
      {type === 'masked' && (
        <MaskedInput
          {...register(name)}
          mask={mask!}
          id={`${scope}-input-${name}`}
        />
      )}

      {type === 'password' && (
        <Input.Password {...register(name)} id={`${scope}-input-${name}`} />
      )}

      {type === 'text' && (
        <Input {...register(name)} id={`${scope}-input-${name}`} />
      )}

      {type === 'number' && (
        <Input {...register(name)} id={`${scope}-input-${name}`} />
      )}

      <div className="ant-form-explain">{errors[name]?.message}</div>
    </Form.Item>
  )
}
